import React from 'react';
import PropTypes from 'prop-types';
import BoutonTelechargementFichier from '../../../../../components/BoutonTelechargementFichier/BoutonTelechargementFichier';

const DisplayLicence = ({ type, numero, fichier, ...otherProps }) => {
    return (
        <div>
            {type} : {numero}{' '}
            {fichier && fichier.filename && (
                <BoutonTelechargementFichier
                    libelle={fichier.filename}
                    uuidFichier={fichier.uuid}
                    id={`fichier_${fichier.filename}`}
                    {...otherProps}
                />
            )}
        </div>
    );
};

DisplayLicence.propTypes = {
    type: PropTypes.string.isRequired,
    numero: PropTypes.string,
    fichier: PropTypes.string,
};

export default DisplayLicence;
